module.exports = __webpack_public_path__ + "img/user-guide-02-03-01.600243a7.png";